module.exports = ":host ::ng-deep .quote-block content .row {\n  background-color: #310b17; }\n  :host ::ng-deep .quote-block content .row .pointer::after {\n    color: #310b17; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/event-container/event-container.style.scss
// module id = 861
// module chunks = 2